import "./src/styles/normalize.css"
import "./src/styles/main.css"
import "./src/styles/styles.css"

import wrapWithProvider from "./wrap-with-provider"
export const wrapRootElement = wrapWithProvider
